import { render, staticRenderFns } from "./email-settings.vue?vue&type=template&id=6bc2db75"
import script from "./email-settings.vue?vue&type=script&lang=ts"
export * from "./email-settings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports